import NotificationModal from '@anm/components/modals/NotificationModal';
import { NotificationElement } from '@anm/hooks/useNotifications';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { brandSelectors } from '../../../../store/modules/brands';
import { videoFolderSelectors } from '../../../../store/modules/videoFolder';
import useCreateBrandFileNotification from '../hooks/useAddToBrandNotification';
import useDeleteFolderNotifications from '../hooks/useDeleteFolderNotifications';
import useDuplicateProjectNotifications from '../hooks/useDuplicateProjectNotifications';
import useMoveProjectNotifications from '../hooks/useMoveProjectNotifications';

export type NotificationModalProps = {};

const Notification: FC<NotificationModalProps> = () => {
  const { duplicateProject, deleteFolder, moveProject } = useSelector(videoFolderSelectors.selectVideoFolders);

  const createBrandFileState = useSelector(brandSelectors.selectCreateBrandFileState);

  const duplicateNotifications = useDuplicateProjectNotifications(duplicateProject);

  const { deleteFolderNotifications } = useDeleteFolderNotifications(deleteFolder);

  const { moveProjNotifications } = useMoveProjectNotifications(moveProject);

  const createBrandFileNotifications = useCreateBrandFileNotification(createBrandFileState);

  const notifications = [
    ...moveProjNotifications,
    ...duplicateNotifications,
    ...deleteFolderNotifications,
    ...createBrandFileNotifications
  ];

  return (
    <>
      {notifications.map(({ id, variant = 'aside', deleteNotification, ...rest }: NotificationElement) => (
        <NotificationModal
          key={id}
          timeout={7000}
          variant={variant}
          onModalClose={() => deleteNotification(id)}
          {...rest}
        />
      ))}
    </>
  );
};

export default Notification;
